function ReusableCupSelected() {
    return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.25" cy="26" r="25.5" fill="#0D0F11" stroke="#0D0F11"/>
            <path
                d="M22.1389 32.75H23.8677H25.5213H27.2501C30.0728 32.75 32.3612 30.4617 32.3612 27.6389V26.3611V22.5278C32.3612 21.8221 31.7891 21.25 31.0834 21.25H22.1389H18.3056C17.5999 21.25 17.0278 21.8221 17.0278 22.5278V26.3611V27.6389C17.0278 30.4617 19.3162 32.75 22.1389 32.75Z"
                fill="#0D0F11" stroke="white" strokeWidth="2"/>
            <path
                d="M33.179 22.5278H35.4278C36.5569 22.5278 37.4722 23.4432 37.4722 24.5723V25.5945C37.4722 26.7236 36.5569 27.6389 35.4278 27.6389H32.3611"
                stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

export default ReusableCupSelected;
